module.exports = __webpack_public_path__ + "static/media/chicken-footer.50f1b69c.svg";